import {
    updateAdvertCardContainerUI,
    updateAdvertResultsFoundInfoInDom,
} from "@modules/global/advert-card-container.ts"
import { insertAllAdvertBanners } from "@modules/news/advert-banners.ts"
import { getUrlParam, removePartialUrlParam, updatePartialUrlParam } from "@modules/news/urlParams/url-param.ts"
import type { ApiFiltersResult } from "@modules/types"
import { isPC } from "@modules/util/device.ts"
import { dispatchGlobalEvent } from "@modules/util/events"
import { updateLinks } from "@modules/util/update-links"
import { updateUrl } from "@modules/util/url"
import { advertCardsContainerElement, advertNewsCardsContainerElement } from "../global/dom.ts"
import { getNextPage, setPagination, updatePaginationButtons, updatePaginationSelect } from "./pagination/pagination"
import { resetAdvertsForUserAndNotify } from "./snapshot-updated-notification"

export function removeSamePageContent() {
    if (isPC()) {
        const container = advertCardsContainerElement()
        if (container) {
            container.innerHTML = ""
        }
        return
    }
    const pageStartElement = advertCardsContainerElement()?.querySelector(`#page-section-${getNextPage() - 1}`)
    let nextElement = pageStartElement?.nextElementSibling
    while (continueRemovingSamePageElement(nextElement)) {
        const oldEl = nextElement
        nextElement = nextElement?.nextElementSibling
        oldEl?.remove()
    }
    pageStartElement?.remove()
}

export function continueRemovingSamePageElement(el: Element | null | undefined) {
    if (!el) {
        return false
    }
    return !el.id.includes("page-section")
}

// TODO via callbacks or event based.
export async function afterFilterApiFetched(
    filterApiResult: ApiFiltersResult | undefined,
    options: { insertAdjacentHTML?: InsertPosition; removeSamePageContent?: boolean } = {},
) {
    if (!filterApiResult) {
        return
    }
    dispatchGlobalEvent("news.filter-api.after-fetch", filterApiResult)
    const advertCardsContainerEl = advertNewsCardsContainerElement()
    if (advertCardsContainerEl) {
        await new Promise((resolve) =>
            requestAnimationFrame(() => {
                if (options.removeSamePageContent) {
                    removeSamePageContent()
                }
                if (options.insertAdjacentHTML) {
                    advertCardsContainerEl.insertAdjacentHTML(options.insertAdjacentHTML, filterApiResult.content)
                } else {
                    advertCardsContainerEl.innerHTML = filterApiResult.content
                }
                resolve(null)
            }),
        )
    }

    updateAdvertCardContainerUI(filterApiResult.advertCount)
    updateUrl(updateDifferentParamsIntoUrl(filterApiResult.seoUrl))
    setPagination(filterApiResult.pagination)
    updatePaginationButtons(filterApiResult.pagination)
    updatePaginationSelect(filterApiResult.pagination)
    updateAdvertResultsFoundInfoInDom(filterApiResult)
    updateLinks()

    insertAllAdvertBanners(true)

    SiteInfo.endsWithLastAdvertInGroup = filterApiResult.endsWithLastAdvertInGroup || false
    SiteInfo.currentSearchHash = filterApiResult.currentSearchHash || ""

    SiteInfo.seoHrefPreviousUrl = filterApiResult.seoHrefPreviousUrl || ""
    SiteInfo.seoHrefNextUrl = filterApiResult.seoHrefNextUrl || ""

    updateLoadNextAdvertsButtonHrefFromString(SiteInfo.seoHrefNextUrl)
    updateLoadPreviousAdvertsButtonHrefFromString(SiteInfo.seoHrefPreviousUrl)

    if (filterApiResult.snapshotUpdatedDueToNewDay || filterApiResult.snapshotUpdatedDueToNewIndex) {
        resetAdvertsForUserAndNotify()
    }
}

function updateDifferentParamsIntoUrl(filterApISeoUrl: string): string {
    const newsSectionUmkreisParam = getUrlParam("umkreis", filterApISeoUrl)
    let newUrl = filterApISeoUrl

    //information Announcement News Page Addition
    const currentUrlSearchParams = new URLSearchParams(window.location.search)
    if (currentUrlSearchParams.get("information-page") && newsSectionUmkreisParam !== "") {
        newUrl = updatePartialUrlParam(
            window.location.pathname + "?" + currentUrlSearchParams.toString(),
            "umkreis",
            newsSectionUmkreisParam,
        )
    } else if (newsSectionUmkreisParam === "") {
        newUrl = removePartialUrlParam(window.location.pathname + "?" + currentUrlSearchParams.toString(), "umkreis")
    }

    return newUrl
}

function updateLoadNextAdvertsButtonHrefFromString(seoHrefNextUrl: string) {
    document.querySelector("#news-page-seo-href-next")?.setAttribute("href", seoHrefNextUrl)
    document.querySelector("#news-page-seo-href-next-bottom")?.setAttribute("href", seoHrefNextUrl)
}
function updateLoadPreviousAdvertsButtonHrefFromString(seoHrefPreviousUrl: string) {
    document.querySelector("#news-page-seo-href-previous")?.setAttribute("href", seoHrefPreviousUrl)
    document.querySelector("#news-page-seo-href-previous-bottom")?.setAttribute("href", seoHrefPreviousUrl)
}
